<template>
  <Slideover
    title="Revision History"
    description="History of quote changes"
    width-class="slideover-lg"
    @close="$emit('close')"
  >
    <div v-if="isLoading" class="p-4 text-center text-muted">
      Loading history...
    </div>
    <div v-else-if="history.length === 0" class="p-4 text-center text-muted">
      No changes recorded yet.
    </div>
    <div v-else class="list-group list-group-flush fs-sm">
      <button
        v-for="revision in history"
        :key="revision.id"
        type="button"
        class="list-group-item list-group-item-action text-start history-drawer-item"
        @click="$emit('view-revision', revision.id)"
      >
        <div class="d-flex justify-content-between gap-2">
          <span class="fw-semibold">
            Revision #{{ revision.revision_number }}
          </span>
          <span class="text-muted fs-xs">
            {{ revision.created_at_display }}
          </span>
        </div>
        <div>{{ revision.summary }}</div>
        <div class="text-muted fs-xs">
          {{ revision.changed_by }} -
          {{ revision.change_count }}
          {{ revision.change_count === 1 ? "change" : "changes" }}
        </div>
      </button>
    </div>
  </Slideover>
</template>

<script setup>
import Slideover from "@/components/Slideover.vue";

defineProps({
  history: {
    type: Array,
    default: () => [],
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

defineEmits(["close", "view-revision"]);
</script>

<style scoped>
.history-drawer-item {
  background-color: transparent;
  color: inherit;
  border-color: inherit;
}

.history-drawer-item:hover,
.history-drawer-item:focus {
  background-color: rgba(0, 0, 0, 0.03);
  color: inherit;
}

:global(.dark-mode) .history-drawer-item:hover,
:global(.dark-mode) .history-drawer-item:focus {
  background-color: rgba(255, 255, 255, 0.04);
}
</style>
